import React from 'react';
import PropTypes from 'prop-types';
import {Glyphicon} from 'react-bootstrap';

class Collapsible extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            isExpanded : false
        }
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle(e){
        e.preventDefault();
        e.target.className.includes('collapsible') && this.setState({
            isExpanded: !this.state.isExpanded,
            height: this.refs.inner.clientHeight
        });
        
    }

    render(){
        const {title, children} = this.props;
        const {isExpanded, height} = this.state;
        const currentHeight = isExpanded ? height : 0;
        return (
            <div className={`panel ${isExpanded ? 'is-expanded' : ''}`} onClick={this.handleToggle}>
                <div className="panel-heading collapsible">
                    <h3 className="collapsible">{title}</h3>
                    <Glyphicon className="collapsible" title="Expand / Collapse" glyph={`${isExpanded ? "chevron-up" : "chevron-down"}`} onClick={this.handleToggle} style={{float: "right", position: "relative", top: "-35px", marginRight: "10px"}}/>
                </div>
                <div className="panel-collapse" style={{height: currentHeight+'px'}}>
                    <div className="panel-body" ref="inner">
                        {children}
                    </div>
                </div>
            </div>
        )
    }

}

Collapsible.propTypes = {
    title: PropTypes.string,
};

export default Collapsible;